import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import "./productosTable.css";
//import ClientesKPICalidadInformacion from "../Clientes/ClientesKPICalidadInformacion";
import { getMonthDiff, getMonthNames, getYearsUntilNow } from "helper/tools";

import { es } from "date-fns/locale";
//import { format } from "date-fns";
import { useAuthStore } from "../../../../store/store";
//import MarcasKPI from "../Clientes/MarcasKPI";
//import ProductosNuevosSmall from "../Clientes/ProductosNuevosSmall";
import TendenciasEfectividadKPI from "../Clientes/TendenciasEfectividadKPI";
import EstatusAsociadosKPI from "../Clientes/EstatusAsociadosKPI";
import { format, parseISO } from "date-fns";

/*
function SectionOption(id = "", title = "", isSelected = false) {
  this.id = id;
  this.title = title;
  this.isSelected = isSelected;
}*/

function CobranzaDashboard({ subSectionId }) {
  //const yearSelectRef = useRef();

  const [months, setMonths] = useState([]);

  const [years, setYears] = useState([]);
  const [yearSelected, setYearSelected] = useState(null);
  const [monthSelected, setMonthSelected] = useState(null);

  const [fechasCorte, setFechasCorte] = useState(null);
  const [selectedFechaCorte, setSelectedFechaCorte] = useState(null);
  //const [fechasCorteResultado, setFechasCorteResultado] = useState(null);

  const fetchData = async (monthIndex, year) => {
    const start = new Date();
    start.setMonth(monthIndex);
    start.setDate(1);
    start.setFullYear(year);

    //const fechaInicial = format(start, "yyyy-MM-dd'T'00:00:00");

    useAuthStore.setState({ productoDashboadDate: start });
  };

  useEffect(() => {
    const date = new Date();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    setYearSelected(year);
    setMonthSelected(monthIndex);

    const wideMonthNames = getMonthNames(es).map((month, index) => ({
      name: month,
      isSelected: monthIndex === index,
    }));
    setMonths(wideMonthNames);

    const yearNames = getYearsUntilNow(es).map((year) => ({
      name: year,
      isSelected: false,
    }));
    setYears(yearNames);

    fetchData(monthIndex, date.getFullYear());

    loadAvailableDates();
  }, []);

  useEffect(() => {
    if (selectedFechaCorte == null) return;

    const date = parseISO(selectedFechaCorte);
    fetchData(date.getMonth(), date.getFullYear());
  }, [selectedFechaCorte]);

  async function loadAvailableDates() {
    /*
    default traer las primeras 8
    */
    //  const ParcialidadesNo = 8;

    //setIsLoading(true);
    /*const toastId = toast.loading(
                              "Creando Orden de Venta...",
                            );*/

    const startDate = new Date(2025, 0, 11, 0, 0, 0);
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 1, 0);

    const months = getMonthDiff(startDate, endDate);

    const parcialidadesNo = months * 2;

    //  const date1 = new Date('2025-01-15');
    //const date2 = new Date('2026-03-20');
    //console.log(getMonthDiff(startDate, endDate)); // Output: 14

    let response = await api
      .demoParcialidades({
        noParcialidades: parcialidadesNo,
        startDate: startDate,
      })
      .catch((e) => {
        //    toast.dismiss(toastId);
        if (e.esError && e.codigoError && e.mensaje) {
          toast.error(`Error al Orden de Venta. ${e.mensaje}`);
          //setIsLoading(false);
          return;
        }
        toast.error("Error al Orden de Venta.");
        //  setIsLoading(false);
      });

    //  setIsLoading(false);
    //toast.dismiss(toastId);

    if (!response) return;

    setFechasCorte(response.data);

    //  toast.success("Orden de Venta creado.");
  }

  return (
    <>
      <div className="separator"></div>

      <div
        className=""
        style={{
          display: "flex",
          alignItems: "center",
          columnGap: "10px",
          width: "310px",
        }}
      >
        {/*  <input ref={dateRangeEleRef} type="text" name="daterange" /> */}

        <div className="form-floating col">
          <select
            className="form-select"
            id="floatingSelect"
            aria-label="Floating label example"
            onChange={(item) => {
              const value = item.currentTarget.value;
              setSelectedFechaCorte(value);
            }}
          >
            <option value="" selected disabled hidden>
              -
            </option>
            {fechasCorte?.map((fechaCorte, index) => {
              //
              //  const start = format(fechaCorte.start, "yyyy-MM-dd'T'00:00:00");

              const startRaw = fechaCorte.start.replace("Z", "");
              /*  const startRaw = fechaCorte.start
                .replace(/[TZ]/, "")
                .replace("-", "/");*/

              const start = format(startRaw, "yyyy-MM-dd");

              //  const start = parse(startRaw, "yyyy-MM-dd", new Date());
              //  const end = format(fechaCorte.end, "yyyy-MM-dd");
              const selected = fechaCorte?.selected ?? false;
              return (
                <option
                  key={start}
                  value={start}
                  selected={selected}
                  onChange={(item) => {
                    const newFechasCorte = [...fechasCorte];
                    newFechasCorte.forEach((fechaCorte, currIndex) => {
                      fechaCorte.selected = currIndex === index;
                      if (fechaCorte.selected) {
                        setSelectedFechaCorte(fechaCorte.start);
                      }
                    });
                  }}
                >
                  {start}
                </option>
              );
            })}
          </select>
          <label htmlFor="floatingSelect">Fecha de Corte Disponibles</label>
        </div>

        {/*      <select
          className="form-select"
          aria-label="Default select example"
          value={monthSelected}
          onChange={(item) => {
            const monthIndex = parseInt(item.currentTarget.value);
            setMonthSelected(monthIndex);
            fetchData(monthIndex, yearSelected);
          }}
        >
          {months.map((item, index) => {
            return (
              <option selected={item.isSelected} value={index}>
                {item.name}
              </option>
            );
          })}
        </select>
*/}
        {/*  <select
          className="form-select"
          aria-label="Default select example"
          value={yearSelected}
          onChange={(item) => {
            const year = parseInt(item.currentTarget.value);
            setYearSelected(item.currentTarget.value);
            //TODO  fetchData(monthIndex);
            yearSelectRef.current = year;
            //fetchData(monthIndex);

            fetchData(monthSelected, year);

            /*  reporteSmallRef.current.changeSelectedMonth(
                  monthSelectRef.current.value,
                  yearSelectRef.current,
                );* /
          }}
        >
          {years.map((item, index) => {
            return (
              <option selected={item.isSelected} value={item.name}>
                {item.name}
              </option>
            );
          })}
        </select>*/}
      </div>

      <div className="bd-example">
        <div className="container  overflow-hidden">
          <div className="row  gx-5">
            <div className="col-5">
              <TendenciasEfectividadKPI />
            </div>

            <div
              className="col card1 recent-sales overflow-auto"
              style={{
                backgroundColor: "transparent",
                borderRadius: "0px",
                marginBottom: "30px",
              }}
            >
              <EstatusAsociadosKPI />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(CobranzaDashboard);
